module.exports = __webpack_public_path__ + "img/es50.1f858658.png";